<template>
  <div class="container">
    <label class="label" :for="id" v-if="showLabel && label">
      <span class="title">{{ label }}</span>
      <div class="right">
        <span
          v-if="max"
          :class="[isOverflow ? 'symbols-overflow' : null, 'symbols']"
          >{{ symbolsCounter }}</span
        >
        <slot name="right" />
      </div>
    </label>
    <slot :id="id" />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    value: String,
    max: String,
    showLabel: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
    },
  },
  computed: {
    isOverflow() {
      return this.value?.length > this.max;
    },
    symbolsCounter() {
      return `${this.value?.length ?? 0}/${this.max}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .label {
    margin-bottom: 6px;
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: 600;
      font-size: 16px;
      line-height: 171%;
      color: #25262c;
    }

    .right {
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      column-gap: 10px;
    }

    .symbols {
      font-weight: 500;
      font-size: 12px;
      line-height: 171%;
      color: #989898;

      &-overflow {
        color: #ec675c;
      }
    }
  }
}
</style>
